import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

import viewIcon from 'images/icons/invite/view.svg';
import closeIcon from 'images/close-icon.svg';
import Tooltip from 'components/ui/Tooltip';

import ViewModal from 'components/Admin/Templates/Views/Show/Modal';
import CloseModal from 'components/Admin/Templates/Views/Close/Modal';

export default function Actions({ row, onClose }) {
  const [showViewModal, setShowViewModal] = useState(false);
  const [showCloseModal, setShowCloseModal] = useState(false);

  return (
    <div style={{ display: 'flex', alignItems: 'baseline' }}>
      <Button
        bsStyle="link"
        className="pl0 pr0 mr10"
        onClick={() => setShowViewModal(true)}
        data-tip="View Details"
      >
        <img src={viewIcon} alt="view details" />
      </Button>

      <Button
        bsStyle="link"
        className="pl0 pr0"
        onClick={() => setShowCloseModal(true)}
        data-tip="Close"
      >
        <img src={closeIcon} alt="close" />
      </Button>

      {showViewModal && (
        <ViewModal row={row} show={showViewModal} onHide={() => setShowViewModal(false)} />
      )}

      {showCloseModal && (
        <CloseModal row={row} show={showCloseModal} onClose={onClose} onHide={() => setShowCloseModal(false)} />
      )}

      <Tooltip />
    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};
